<template lang="html">
  <v-container grid-list-lg>
    <v-layout wrap>
      <v-flex
        xs12
        lg10
        xl8
        mx-auto
      >
        <v-layout wrap>
          <v-flex xs12>
            <v-card>
              <v-card-title class="hedline">
                Action code mapping
              </v-card-title>
              <v-simple-table>
                <tbody>
                  <tr
                    v-for="(type, typeCode) in interactionTypes"
                    :key="typeCode"
                  >
                    <td
                      class="py-2 pr-1 font-weight-medium"
                      width="10"
                    >
                      {{ typeCode }}
                    </td>
                    <td
                      class="py-2 px-1"
                      width="40%"
                    >
                      <v-text-field
                        v-model="type.name"
                        label="friendly name"
                        outlined
                        single-line
                        hide-details
                        @change="save(typeCode)"
                      />
                    </td>
                    <td
                      class="py-2 px-1"
                      width="30%"
                    >
                      <v-text-field
                        v-model="type.icon"
                        label="icon"
                        outlined
                        single-line
                        hide-details
                        :append-icon="type.icon"
                        @change="save"
                      />
                    </td>
                    <td
                      class="py-2 px-1"
                      width="30%"
                    >
                      <v-text-field
                        v-model="type.color"
                        label="color"
                        outlined
                        single-line
                        hide-details
                        :color="type.color"
                        @change="save"
                      >
                        <template
                          v-if="type.color"
                          #append
                        >
                          <v-icon :color="type.color">
                            fiber_manual_record
                          </v-icon>
                        </template>
                      </v-text-field>
                    </td>
                    <td
                      class="py-2 px-1"
                      width="10"
                    >
                      <v-checkbox
                        v-model="type.primary"
                        label="primary"
                        outlined
                        single-line
                        hide-details
                        class="ma-0"
                        @change="save"
                      />
                    </td>
                    <td
                      class="py-2 px-1"
                      width="10"
                    >
                      <v-btn
                        text
                        icon
                        color="grey"
                        @click="deleteType(typeCode)"
                      >
                        <v-icon>close</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <v-card-text>
                <SiVariableEditor
                  variable-term="interaction_code"
                  :existing-variables="interactionTypes"
                  @variable="newType"
                />
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { forEach } from 'lodash'
import { rtdb } from '@/plugins/firebase'
import helpers from '@/mixins/helpers'
import binder from '@/mixins/binder'

export default {
  mixins: [ helpers, binder ],
  props: {

  },
  data () {
    return {
      interactionTypes: {},
      indexedInteractionTypes: {}
    }
  },
  beforeMount () {
    const callback = (v) => {
      forEach(v, (type, id) => {
        if (!this.interactionTypes[id]) {
          this.$set(this.interactionTypes, id, { id: id, notSet: true })
        }
      })
    }
    this.$bindRtdb('interactionTypes', `clientPath/_mappingTypes`, { loader: true })
    this.$bindRtdb('interactionTypesUnmapped', `clientPath/_indexInteractions`, { callback} )
    // this.$bindxxx(rtdb.ref(`clientPath/_mappingTypes`), 'interactionTypes', true)
    // this.$bindxxx(rtdb.ref(`clientPath/_indexInteractions`), v => {
    //   forEach(v, (type, id) => {
    //     if (!this.interactionTypes[id]) this.$set(this.interactionTypes, id, { id: id, notSet: true })
    //   })
    // })
    this.$store.commit('set_appBarTitle', {title: 'Client Path Mapping', icon: 'track_changes'})

  },
  methods: {
    newType (name) {
      rtdb.ref(`clientPath/_mappingTypes/${name}`).set({ id: name })
    },
    save (id) {
      rtdb.ref(`clientPath/_mappingTypes`).set(this.interactionTypes)
      if (id) this.checkNotSet(id)
    },
    checkNotSet (id) {
      if (this.interactionTypes[id].notSet) rtdb.ref(`clientPath/_mappingTypes/${id}/notSet`).set(null)
    },
    deleteType (name) {
      rtdb.ref(`clientPath/_mappingTypes/${name}`).set(null)
    }
  }
}
</script>

<style lang="css" scoped>

</style>
